module.exports = __webpack_public_path__ + "static/media/verao-partitura-1.932262b9.png";